import React from "react";
import ProgressStepIcon from "@ui/icons/progress-step-icon";

const ProgressIndicator = (data) => {
    const { steps, currentIndex, percentComplete } = data;
    let indicatorProgressPercent = percentComplete;

    if (percentComplete == 100) {
        if (steps && steps[currentIndex].isCurrent) {
            indicatorProgressPercent = percentComplete - 10;
        }
    }

    return (
        <div
            className="bg-[#3B7D25] h-[5px] rounded-full"
            style={{ width: indicatorProgressPercent + "%" }}
        ></div>
    );
};

const ProgressSummary = (data) => {
    const { steps, currentIndex } = data;
    const startLabelHeading = steps[currentIndex].description;
    const startLabelSubHeading = steps[currentIndex].subText;
    const endLabel = `(${currentIndex + 1} of ${steps.length})`;

    return (
        <div className="flex">
            <div className="flex-auto w-4/5 justify-between">
                <p className="text-m font-bold text-black pb-1">
                    {startLabelHeading}
                </p>
                <p className="text-xs">{startLabelSubHeading}</p>
            </div>
            <div className="flex-auto align-right">
                <p className="text-sm text-right max-w-l text-skin-light text-black">
                    {endLabel}
                </p>
            </div>
        </div>
    );
};

const DesktopProgressSteps = ({ steps }) => {
    const length = steps?.length ?? 0;

    if (!length) return null;

    return steps.map((step, index) => {
        const barStyle = { width: step.isCurrent ? "80%" : "100%" };
        return (
            <div key={index} className={`${index < length - 1 ? "grow" : ""}`}>
                <div className="flex items-center gap-2 mb-3">
                    <div>
                        <ProgressStepIcon
                            isComplete={step.isComplete}
                            isActive={step.isCurrent}
                            label={index + 1}
                            className="text-xs"
                        />
                    </div>
                    <div
                        className={`whitespace-nowrap ${
                            step.isCurrent
                                ? "text-skin-primary font-semibold"
                                : ""
                        }`}
                    >
                        {step.text}
                    </div>
                    {index < length - 1 && (
                        <div
                            className={`bg-skin-light grow mr-2`}
                            style={{ height: "2px", minWidth: "16px" }}
                        ></div>
                    )}
                </div>
                <div className="w-full bg-skin-light">
                    <div
                        className={`w-full ${
                            step.isCurrent || step.isComplete
                                ? "bg-skin-primary"
                                : "bg-skin-light"
                        } h-[4px] ${index == 0 ? "rounded-l-full" : ""} ${
                            step.isCurrent ? "rounded-r-full" : ""
                        }`}
                        style={barStyle}
                    ></div>
                </div>
            </div>
        );
    });
};

const DesktopProgressBar = ({ data }) => {
    return (
        <div className="hidden md:flex text-xs">
            <DesktopProgressSteps steps={data.steps} />
        </div>
    );
};

const MobiProgressBar = ({ data }) => {
    const { steps } = data;
    const currentStepIdx = steps.findIndex((s) => s.isCurrent);
    const progressPercent = ((currentStepIdx + 1) / steps.length) * 100;
    return (
        <div className="md:hidden block w-full">
            <ProgressSummary steps={steps} currentIndex={currentStepIdx} />
            <div className="w-full bg-skin-light rounded-full h-[5x] mt-4">
                <ProgressIndicator
                    steps={steps}
                    currentIndex={currentStepIdx}
                    percentComplete={progressPercent}
                />
            </div>
        </div>
    );
};

const ProgressBar = ({ data }) => {
    return (
        <>
            <MobiProgressBar data={data} />
            <DesktopProgressBar data={data} />
        </>
    );
};

export default ProgressBar;
